import RoutesMap from "../../route_control/RouteControl"
import { lazy } from "react"

const AddGrn = lazy(() => import("../../pages/assets/grn/AddGrn"))
const UpdateGrn = lazy(() => import("../../pages/assets/grn/UpdateGrn"))
const GrnList = lazy(() => import("../../pages/assets/grn/GrnList"))
const AssetDetails = lazy(() => import("../../pages/assets/grn/AssetDetails"))
const AddAssetIssue = lazy(() => import('../../pages/assets/asset_issue/AddAssetIssue'))
const AssetIssueList = lazy(() => import('../../pages/assets/asset_issue/AssetIssueList'))
const AddToolsPartsTransfer = lazy(() => import('../../pages/assets/tools_parts_transfer/AddToolsPartsTransfer'))
const UpdateToolsPartsTransfer = lazy(() => import('../../pages/assets/tools_parts_transfer/UpdateToolsPartsTransfer'))
const ToolsPartsTransferList = lazy(() => import('../../pages/assets/tools_parts_transfer/ToolsPartsTransferList'))
const AddToolsPartsReturn = lazy(() => import('../../pages/assets/tools_parts_return/AddToolsPartsReturn'))
const ToolsPartsReturnList = lazy(() => import('../../pages/assets/tools_parts_return/ToolsPartsReturnList'))
const AssetLocation = lazy(() => import("../../pages/assets/asset_location/AssetLocation"))
const AssetLocationDetails = lazy(() => import("../../pages/assets/asset_location/AssetLocationDetails"))
const AddInventory = lazy(() => import("../../pages/assets/inventory/AddInventory"))
const GrnDetails = lazy(() => import("../../pages/assets/grn/GrnDetails"))
const StockList = lazy(() => import("../../pages/assets/stock/StockList"))
const PendingAssetConversionList = lazy(() => import("../../pages/assets/stock/PendingAssetConversionList"))
const AddStock = lazy(() => import("../../pages/assets/stock/AddStock"))
const AddAmc = lazy(() => import("../../pages/assets/amc/AddAmc"))
const UpdateAmc = lazy(() => import("../../pages/assets/amc/UpdateAmc"))
const AmcList = lazy(() => import("../../pages/assets/amc/AmcList"))
const AmcDetails = lazy(() => import("../../pages/assets/amc/AmcDetails"))
const AssetList = lazy(() => import("../../pages/assets/asset/AssetList"))

export const AssetRouteImport = {
    RoutesMap,
    AddGrn,
    UpdateGrn,
    GrnList,
    AddAssetIssue,
    AssetIssueList,
    AddToolsPartsTransfer,
    UpdateToolsPartsTransfer,
    ToolsPartsTransferList,
    AddToolsPartsReturn,
    ToolsPartsReturnList,
    AssetLocation,
    AssetLocationDetails,
    AssetDetails,
    AddInventory,
    GrnDetails,
    StockList,
    PendingAssetConversionList,
    AddStock,
    AddAmc,
    UpdateAmc,
    AmcList,
    AmcDetails,
    AssetList,
}